export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/animation_for_streamers.10925ff.svg";